module.exports = __webpack_public_path__ + "static/media/snare.e0862546.mp3";